import {
  ref, computed, watch, nextTick,
} from 'vue';
import { useStore } from 'vuex';
import DatastoreConnect from '@/assets/js/DatastoreFunctions/datastore-interface';
import { useEditorStore } from '@/stores/useEditorStore.js';
import { storeToRefs } from 'pinia';

export default function useTasksHistory(reviewSettings, currentTaskImage, activeImageIndex) {
  const store = useStore();
  const datastore = new DatastoreConnect(store.state.enterpriseServerUrl);
  const editorStore = useEditorStore();
  const {
    currentSample,
  } = storeToRefs(editorStore);

  const doneImages = ref([]);

  const doneImageOpen = computed(() => {
    if (currentTaskImage.value && currentSample.value.imageObj.id !== currentTaskImage.value.id) {
      return true;
    }
    return false;
  });

  // Methods
  async function getTaskDoneImagesByUser() {
    const params = {
      dataset_id: reviewSettings.value.reviewTask.dataset_id,
      review_task_id: reviewSettings.value.reviewTask.id,
      annotation_set_id: reviewSettings.value.reviewTask.dest_annotation_set_id,
      username: store.state.user.user.username,
    };
    const resp = await datastore.getTaskDoneImagesByUser(params)
      .catch((error) => {
        console.error('Error fetching done images:', error);
        return null;
      });
    
    if (!resp || resp.error) {
      if (resp && resp.error) {
        console.error('API error fetching done images:', resp.error);
      }
      return [];
    }
    
    // Handle both direct array response and object with images property
    const images = Array.isArray(resp.result) ? resp.result : (resp.result?.images || []);
    console.log('Loaded done images:', images.length, 'images');
    return images;
  }

  function switchToTaskImage(imageIndex) {
    activeImageIndex.value = imageIndex;
    if (imageIndex >= 0) {
      currentSample.value.imageObj = doneImages.value[imageIndex];
    } else {
      currentSample.value.imageObj = currentTaskImage.value;
    }
    nextTick(() => { currentSample.value.annotations = (currentSample.value.imageObj.annotations || []); });
  }

  function switchToNextTaskImage() {
    if (activeImageIndex.value > -1) {
      switchToTaskImage(activeImageIndex.value - 1);
    }
  }

  function switchToPreviousTaskImage() {
    if (activeImageIndex.value < (doneImages.value.length - 1)) {
      switchToTaskImage(activeImageIndex.value + 1);
    }
  }

  return {
    doneImages,
    doneImageOpen,
    getTaskDoneImagesByUser,
    switchToTaskImage,
    switchToNextTaskImage,
    switchToPreviousTaskImage,
  };
}
